module.exports = __webpack_public_path__ + "img/logo-ntrack.21bc6428.svg";